import { CONNECTION_HOST } from "../../environment-variables";

export const liabilityController = `${CONNECTION_HOST}/insurance-package-request/liability`;
